// extracted by mini-css-extract-plugin
export default {"button":"style_button__cQ5np","desktop":"style_desktop__Ko+kM","mobile":"style_mobile__YiXYU","laptop":"style_laptop__dD-Hq","v3":"style_v3__PCAu5"};